export const getBoundary = (markers = [], padding = 0.001) => {
  const [sw, ne] = [
    [Number.POSITIVE_INFINITY, Number.POSITIVE_INFINITY],
    [Number.NEGATIVE_INFINITY, Number.NEGATIVE_INFINITY]
  ];

  markers.forEach(({ long, lat }) => {
    if (long > ne[0]) {
      ne[0] = long;
    }
    if (long < sw[0]) {
      sw[0] = long;
    }
    if (lat > ne[1]) {
      ne[1] = lat;
    }
    if (lat < sw[1]) {
      sw[1] = lat;
    }
  });

  //Upcoming manipulations are to force the
  // markers in the top region of the screen
  // to prevent them from being overlapped by
  // map controls

  const v = ne[1] - sw[1];
  const h = ne[0] - sw[0];

  if (v < (h * 8) / 9) {
    sw[1] = ne[1] - ((ne[0] - sw[0]) * 16) / 9;
  } else if (v === 0) {
    sw[1] = ne[1] - padding * 2;
  } else {
    sw[1] = ne[1] - v * 2.5;
  }

  sw[0] = sw[0] - padding;
  sw[1] = sw[1] - padding;

  ne[0] = ne[0] + padding;
  ne[1] = ne[1] + padding;

  return [sw, ne];
};
